// export const BASE_URL = "https://jogi-backend.vercel.app/";
// export const BASE_URL = "http://13.202.15.25/";
// export const BASE_URL = "https://jogi-backend.onrender.com/";
export const BASE_URL = "https://vaidya-backend-lxwn.onrender.com/";
// export const BASE_URL = "http://localhost:8080/";
